import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupUserDetail(): void {
  applicationModuleRegistry.register({
    entry: 'user-details',
    icon: undefined,
    id: 'user-details',
    name: 'module.user-detail',
    route: ApplicationRoute.USER_DETAILS,
  });
}
